export function loopThroughGrid(
  startX: number,
  startY: number,
  endX: number,
  endY: number,
  callback: (x: number, y: number) => void
): void {
  if (startX > endX || startY > endY) return;

  for (let x = startX; x < endX; x++) {
    for (let y = startY; y < endY; y++) {
      callback(x, y);
    }
  }
}

export function shuffle<T>(array: T[]): T[] {
  for (let i: number = array.length - 1; i > 0; i--) {
    const j: number = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }

  return array;
}

export function pick<T>(array: T[]): T | null {
  return array[Math.floor(Math.random() * array.length)] || null;
}

export function removeItem<T>(array: T[], itemToRemove: T): T[] {
  const index: number = array.indexOf(itemToRemove);
  index !== -1 && array.splice(index, 1);
  return array;
}

export function wrapIndex(array: unknown[], index: number): number {
  if (index >= array.length) {
    return 0;
  } else if (index < 0) {
    return Math.max(0, array.length - 1);
  } else {
    return index;
  }
}

export function last<T>(array: T[]): T {
  return array[array.length - 1];
}
